  $(document).ready(function() {
    // Initialize the total price
    var totalPrice = 0;

    // Function to update the total price
    function updateTotalPrice() {
      $('.product-checkboxes:checked').each(function() {
        var productPrice = parseFloat($(this).data('price'));
        totalPrice += productPrice;
      });
      $('.total-price').text('$' + totalPrice.toFixed(2));
    }

    // Event handler for checkbox changes
    $('.product-checkboxes').change(function() {
      // Check if the checkbox is checked
      if ($(this).is(':checked')) {
        var productPrice = parseFloat($(this).data('price'));
        totalPrice += productPrice;
      } else {
        var productPrice = parseFloat($(this).data('price'));
        totalPrice -= productPrice;
      }
      $('.total-price').text('$' + totalPrice.toFixed(2));
    });
  });



$(".openbtn").click(function () {
  $("#myNav").addClass("active");
});

$(".closebtn").click(function () {
  $("#myNav").removeClass("active");
});

$(".search a").click(function () {
  $(".search-bar").addClass("active");
});

$(".search-close-ic a").click(function () {
  $(".search-bar").removeClass("active");
});
$(function () {
  let myLazyLoad = new LazyLoad({
    elements_selector: ".lazy",
  });
});
new WOW().init();
// Siderbar
function openmodule() {
  document.querySelector(".module").classList.add("show");
}

function closemodule() {
  document.querySelector(".module").classList.remove("show");
}
$(".top__mian").slick({
  infinite: true,
  speed: 30000,
  autoplaySpeed: 0,
  arrows: false,
  dots: false,
  autoplay: true,
  slidesToShow: 5,
  slidesToScroll: 3,
  cssEase: "linear",
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
$(".review__slider").slick({
  infinite: true,
  autoplay: false,
  centerMode: false,
  arrows: true,
  dots: false,
  slidesToShow: 2,
  slidesToScroll: 1,
  cssEase: "linear",
});
$(".pro__slider--alt").slick({
  infinite: true,
  autoplay: false,
  centerMode: false,
  arrows: true,
  dots: false,
  slidesToShow: 3,
  slidesToScroll: 1,
  cssEase: "linear",
});
$(".prodetail__slider").slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  fade: true,
  asNavFor: ".proNav__slider",
});
$(".proNav__slider").slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  asNavFor: ".prodetail__slider",
  dots: false,
  centerMode: false,
  arrows: false,
  focusOnSelect: true,
});


var swiper = new Swiper(".swiper", {
  slidesPerView: 10,
  spaceBetween: 0,
  centeredSlides: true,
  pagination: {
    clickable: true,
  },
    breakpoints: {
    320: {
      slidesPerView: 2,
      spaceBetween: 10,
      centeredSlides: false,
      pagination: {
        clickable: true,
      },
    },
    520: {
      slidesPerView: 3,
      spaceBetween: 10,
      centeredSlides: false,
      pagination: {
        clickable: true,
      },
    },
  },
});
var swiper = new Swiper('.swiper-container', {
  slidesPerView: 1,
  spaceBetween: 10,
  
})
document.addEventListener("DOMContentLoaded", function () {
  var header = document.getElementById("main_header");
  var sticky = header.offsetTop;

  window.onscroll = function () {
    if (window.pageYOffset > sticky) {
      header.classList.add("fixed");
    } else {
      header.classList.remove("fixed");
    }
  };

  if (window.pageYOffset > sticky) {
    header.classList.add("fixed");
  }
});
$(".tab-prod-slider").slick({
  infinite: false,
  autoplay: false,
  arrows: true,
  dots: false,
  slidesToShow: 3,
  slidesToScroll: 1,
  cssEase: "linear",
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        centerMode:false,
        arrows: false,
        dots:true,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
// $(".owl-carousel").owlCarousel({
//   stagePadding: 50,
//   loop: false,
//   margin: 10,
//   items: 3,
//   nav: true,
//   responsive: {
//     0: {
//       items: 1,
//     },
//     600: {
//       items: 2,
//     },
//     1000: {
//       items: 3,
//     },
//   },
// });
// Siderbar
function opencart() {
  document.querySelector(".side__menu").classList.add("show");
}

function closecart() {
  document.querySelector(".side__menu").classList.remove("show");
}
$(".test-slider").slick({
  dots: false,
  infinite: true,
  autoplay: true,
  arrows: true,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 1,
  prevArrow:
    '<div class="slick-prev"><i class="fal fa-arrow-circle-left"></i></div>',
  nextArrow:
    '<div class="slick-next"><i class="fal fa-arrow-circle-right"></i></div>',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: true,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ],
});
